<template>
    <div v-if="busTransfer[0] && busTransfer[0].length"
         :class="['bus-block block',{'show': show}]">

        <!--Блок разварачивания-->
        <div @click="blockToggle('bus')"
             class="block-toggle-bar align-center justify-between">
            <div class="block-name align-center justify-center">
                <svg width="16px" height="19px" fill="var(--white-color)" fill-opacity="0.7">
                    <use xlink:href="../../../assets/images/sprite.svg#bus"></use>
                </svg>
                <span class="ml-8">{{ localizeList.busTransfer }}</span>
            </div>
            <svg width="8px" height="12px" fill="var(--white-color)" class="angle-icon">
                <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
            </svg>
        </div>
        <div v-if="show"
             class="bus-info-wrap">
<!--            <div class="bus-info-header align-center justify-between">-->
<!--                <h3 class="bus-headline">{{ busData.placeFrom }} – {{ busData.placeTo }}</h3>-->
<!--            </div>-->
            <div v-for="(item, key) in busTransfer"
                 :key="key"
                 class="bus-info">
                <div class="align-center mb-6">
                    <h3 class="bus-headline">{{ getBusFullPath(item) }}</h3>
                    <span v-show="settings.UseBusSeatChecks !== 0"
                          @click="rightModalBusInfo(item)"
                          class="more-info-link ml-8 nowrap pointer">
                        {{ localizeList.seatingPlan }}
                    </span>
                </div>
                <span :style="{ 'opacity': item[0].delta ? 1 : 0 }" class="delta">
                    {{ item[0].delta > 0 ? "+" : "" }}{{ correctPrice(item[0].delta) }} {{  getCurrencyDisplayBySettings(tourCardData.tourCurrency) }}
                </span>
                <div @click="changeBus(key)"
                     :class="['bus-group', {'selected': busData.selected === key}, {'single': busTransfer.length === 1}]">
                    <div v-for="(item2, key2) in item"
                         :key="key2"
                         class="bus-coontent">
                        <div class="date-info">
                            <span class="day-info dark-small-bold-text mr-10">
                                {{ getCorrectDate(item2) }}
                            </span>
                            <span class="time-info dark-small-bold-text nowrap">{{ item2.timeFrom }} – {{ item2.timeTo }}</span>
                        </div>
                        <div class="bus-transfer-info">
                            <div class="bus-transfer-code ellipsis">{{ item2.cityFrom }} – {{ item2.cityTo }}</div>
                            <p class="grey-text-small ellipsis">
                                {{ item2.busTransfer }}
                            </p>
                        </div>
                        <div class="details-info align-center">
                            <!-- <span class="grey-text-small mr-4">
                                {{ getQuotaText(item2.busTypeSelected.allData.QuotaStatus) }}
                            </span>
                            <icon :name="getQuotaName(item2.busTypeSelected.allData.QuotaStatus)"
                                  width="16px" height="16px" fill="var(--white-color)"/> -->
                            <!-- Изменил на вариант через popover по Task 67986 -->
                            <div class="popover-link"
                                 @mouseleave="hidePopover()"
                                 @mouseenter="showPopover(getQuotaText(item2.busTypeSelected.allData.QuotaStatus), $event)">
                                 <icon :name="getQuotaName(item2.busTypeSelected.allData.QuotaStatus)" fill="var(--white-color)" width="16px" height="16px"/>
                            </div>
                        </div>
                        <base-select :items="item2.busType"
                                     :cost-changed="item2.costChanged"
                                     @click.native="stop()"
                                     @change="changeBusType(key, key2, $event)"
                                     v-model="item2.busTypeSelectedValue"
                                     class="bus-class"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bus",
        props: {
            busTransfer: {
                type: Array,
                default: () => []
            },
            tourists: {
                type: Array,
                default: () => [1,0]
            },
            busData: {
                type: Object,
                default: () => {}
            },
            tourCardData: {
                type: Object,
                default: () => {}
            },
            show: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                stopSelect: false
            }
        },
        computed: {
            settings() {
                return this.$store.getters['getSettings']
            },
            busDeltaLength() {
                let res = 0;
                this.busTransfer.forEach(x => {
                    let newLength = Math.abs(x[0].delta) + this.tourCardData.currency;
                    if (newLength.length > res) {
                        res = newLength.length
                    }
                });

                return res
            },
        },
        methods: {
            toCapitalize(str) {
                return str[0].toUpperCase() + str.slice(1).toLowerCase()
            },
            getBusFullPath(item) {
                let res = "";
                item.forEach(x => {
                    const depCity = this.toCapitalize(x.cityFrom);
                    if (!res) res = depCity;
                    else {
                        res += ` – ${depCity}`
                    }
                });
                const lastCity = this.toCapitalize(item[item.length-1].cityTo);
                res += ` – ${lastCity},`;

                const adult = this.tourists[0] > 1 ? this.localizeList.adults2 : this.localizeList.adult;
                const child = this.tourists[1] > 1 ? this.localizeList.children : this.localizeList.child;
                res += ` ${this.tourists[0]} ${adult}`;
                if (this.tourists[1]) res += `, ${this.tourists[1]} ${child}`;

                return res
            },
            getCorrectDate(item) {
                let date = item.allData.BeginDateTime;
                date = date.split('T')[0].split('-').reverse().join('.');

                return date
            },
            getTimeDuration(item) {
                return item.timeDuration[0] +" "+ this.localizeList.hourTextUpper +" "+ item.timeDuration[1] +" "+ this.localizeList.minutesTextUpper
            },
            rightModalBusInfo(item, enabled = true) {
                if (!enabled) return;

                this.$emit("rightModalBusInfo", item.map(x => {
                    return {...x.allData, transportKey: x.busTypeSelected.allData.Transport.Key}
                }))
            },
            stop() {
                this.stopSelect = true
            },
            changeBus(key) {
                if (key === this.busData.selected || this.stopSelect) {
                    this.stopSelect = false;
                    return
                }
                this.$emit('changeBus', key)
            },
            changeBusType(key, key2, e) {
                this.$emit('changeBusType', [key, key2, e])
            },
            getCurrencyDisplayBySettings(rate){
                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            correctPrice(val) {
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            blockToggle() {
                this.$emit("toggle", !this.show)
            },
            getQuotaName(quota) {
                if (!quota) {
                    return null
                }
                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = "not-aviailable"
                } else if (quota.PlacesStatus === 4) {
                    res = "request"
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    res = "less"
                } else {
                    res = "aviailable"
                }
                return res
            },
            getQuotaText(quota) {
                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = this.localizeList.quotaHasNoPlaces
                } else if (quota.PlacesStatus === 4) {
                    res = this.localizeList.onRequest
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                    res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                } else {
                    res = this.localizeList.available
                }
                return res
            },
            showPopover(text, e, preType = false) {
                let rect = e.target.getBoundingClientRect();
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height,
                    preType
                };
                this.$store.dispatch('A_SHOW_POPOVER', res);

                if (preType) {
                    document.querySelector('.popover-title').style.maxWidth = 'unset'
                } else {
                    document.querySelector('.popover-title').style.maxWidth = '320px'
                }
            },
            hidePopover() {
                this.$store.dispatch('A_HIDE_POPOVER');
                document.querySelector('.popover-title').style.maxWidth = '200px'
            }
        }
    }
</script>

<style scoped>
    .block {
        background: var(--white-color);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
        border-radius: 4px;
        margin-bottom: 12px;
        transition: all .3s;
    }

    .block .block-toggle-bar {
        border-radius: 4px;
        background: var(--primary-color);
        padding: 12px 16px;
        cursor: pointer;
    }

    .block.show .block-toggle-bar {
        border-radius: 4px 4px 0 0;
    }

    .block .block-toggle-bar .block-name span {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--white-color);
    }

    .block .block-toggle-bar .angle-icon {
        transform: rotate(-90deg);
        transition: all .2s;
    }

    .block.show .block-toggle-bar .angle-icon {
        transform: rotate(90deg);
        transition: all .2s;
    }

    /***BUS BLOCK***/
    .basket .bus-info-header {
        padding: 20px 28px 0
    }

    .basket .bus-info {
        padding: 16px 28px 20px;
    }

    .basket .bus-info .bus-headline {
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: #1D1D1D;
    }

    .basket .bus-info .bus-group {
        position: relative;
        background-color: var(--lighten-2-color);
        border-radius: 6px;
    }

    .basket .bus-info .bus-group.selected {
        border: 3px solid var(--primary-color);
        margin: -3px;
    }
    .basket .bus-info .bus-group.selected.single {
        border: none;
        margin: 0;
    }

    .basket .bus-info .delta {
        font-weight: bold;
        font-size: 18px;
        color: #727272;
        display: inline-block;
        line-height: 0;
    }

    .basket .bus-info .bus-group .bus-coontent {
        display: grid;
        align-items: center;
        grid-template-columns: 208px minmax(0,auto) 26px 240px;
        padding: 12px 16px 12px 12px;
        grid-gap: 10px;
    }

    .basket .bus-info .bus-group .bus-coontent:not(:last-child) {
        border-bottom: 1px solid #E0E0E0;
    }

    .basket .bus-info .bus-group .bus-coontent .date-info {
        display: flex;
    }

    .basket .bus-info .bus-group .bus-coontent .date-info .day-info,
    .basket .bus-info .bus-group .bus-coontent .date-info .time-info {
        line-height: normal;
    }

    .basket .bus-info .bus-group .bus-coontent .bus-transfer-info .bus-transfer-code {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 4px;
        color: var(--primary-color);
    }

    .basket .bus-info .bus-group .bus-coontent .details-info svg {
        min-width: 20px;
    }

    .basket .bus-info .more-info-link {
        font-size: 13px;
        line-height: 28px;
        color: var(--primary-color);
        cursor: pointer;
        transition: all .2s;
    }

    .basket .bus-info .more-info-link:hover {
        color: #55b4f9;
    }

    .basket .bus-info .bus-group .bus-coontent /deep/ .bus-class.base-select .select {
        background-color: var(--white-color);
        padding-top: 8px;
        padding-bottom: 8px;
        padding-right: 26px;
    }

</style>
